import React from 'react';
import { supabase } from '../lib/supabase';
import './Dashboard.css';

function avatarColor(id) {
  const palette = ['#7c3aed', '#2563eb', '#059669', '#b45309', '#db2777', '#0891b2', '#dc2626', '#65a30d'];
  let hash = 0;
  for (let i = 0; i < id.length; i++) {
    hash = id.charCodeAt(i) + ((hash << 5) - hash);
  }
  return palette[Math.abs(hash) % palette.length];
}

const InvitesPanel = ({
  invites,
  pendingFriends,
  onlineUserIds,
  onRefresh,
  onAccept,
  onFriendAccept,
  onFriendDecline,
}) => {
  const handleAccept = async (invite) => {
    await supabase
      .from('chat_invites')
      .update({ status: 'accepted' })
      .eq('id', invite.id);
    onRefresh();
    onAccept(invite);
  };

  const handleDecline = async (invite) => {
    await supabase
      .from('chat_invites')
      .update({ status: 'declined' })
      .eq('id', invite.id);
    onRefresh();
  };

  return (
    <div className="dash-panel">
      <h1 className="dash-panel-title">Invites</h1>

      <div className="dash-section">
        <p className="dash-section-label">Room Invites</p>
        {invites.length === 0 ? (
          <p className="dash-empty">No pending room invites.</p>
        ) : (
          invites.map(invite => {
            const inviter = invite.profiles;
            const inviterName = inviter?.display_name || inviter?.username || 'Someone';
            const roomName = invite.chats?.name || 'a room';

            return (
              <div key={invite.id} className="dash-person-card">
                <div
                  className="dash-person-avatar"
                  style={{ background: avatarColor(invite.invited_by) }}
                >
                  {inviterName.charAt(0).toUpperCase()}
                </div>
                <div className="dash-person-info">
                  <div className="dash-person-name">{roomName}</div>
                  <div className="dash-person-handle">Invited by {inviterName}</div>
                </div>
                <div className="dash-card-actions">
                  <button className="dash-btn" onClick={() => handleAccept(invite)}>
                    Accept
                  </button>
                  <button
                    className="dash-btn dash-btn-secondary"
                    onClick={() => handleDecline(invite)}
                  >
                    Decline
                  </button>
                </div>
              </div>
            );
          })
        )}
      </div>

      <div className="dash-section">
        <p className="dash-section-label">Friend Invites</p>
        {pendingFriends.length === 0 ? (
          <p className="dash-empty">No pending friend invites.</p>
        ) : (
          pendingFriends.map(friendInvite => {
            const requester = friendInvite.requester;
            const requesterName = requester?.display_name || requester?.username || 'Someone';
            const isOnline = onlineUserIds?.has(requester?.id);

            return (
              <div key={friendInvite.id} className="dash-person-card">
                <div
                  className="dash-person-avatar"
                  style={{ background: avatarColor(friendInvite.requester_id) }}
                >
                  {requesterName.charAt(0).toUpperCase()}
                </div>
                <div className="dash-person-info">
                  <div className="dash-person-name-row">
                    <div className="dash-person-name">{requesterName}</div>
                    {isOnline && <span className="nav-friend-status" title="Online" aria-label="Online" />}
                  </div>
                  {requester?.username && <div className="dash-person-handle">@{requester.username}</div>}
                </div>
                <div className="dash-card-actions">
                  <button className="dash-btn" onClick={() => onFriendAccept(friendInvite)}>
                    Accept
                  </button>
                  <button
                    className="dash-btn dash-btn-secondary"
                    onClick={() => onFriendDecline(friendInvite)}
                  >
                    Decline
                  </button>
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default InvitesPanel;
